export function truncateWithEllipsis(text: string, maxLength: number): string {
  if (maxLength <= 0) {
    return '...';
  }

  if (text.length <= maxLength) {
    return text;
  }

  return `${text.slice(0, maxLength).trimEnd()}...`;
}
